import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { gtmTracker, GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CRATagsTooltip } from './CRATagsTooltip';
import { useCRATags } from './StatusCellRenderer/hooks/useCRATags';
import styles from './reachCellRenderer.module.scss';

const GTM_PREFIX = 'CRA_Tags: ';

const ReachCellRenderer = ({ data, msgIdPrefix }) => {
    const { id: creativeId, campaignId, accountName } = data || {};
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    const { shouldRenderTooltip, craTags, publishers, initialSelected } = useCRATags({
        data,
    });

    const displayText = useMemo(() => {
        if (!shouldRenderTooltip) {
            return <FormattedMessage id={`${msgIdPrefix}.no-opportunity`} defaultMessage="-" />;
        }

        return <FormattedMessage id={`${msgIdPrefix}.opportunity`} defaultMessage="View Opportunity" />;
    }, [shouldRenderTooltip, msgIdPrefix]);

    const onMouseEnter = useCallback(() => {
        setIsTooltipVisible(true);
        gtmTracker.trackEvent(GTM_EVENTS.USABILITY, {
            component: `${GTM_PREFIX}Tooltip Visible`,
            value: accountName,
        });
    }, [accountName]);

    const onMouseLeave = useCallback(() => {
        setIsTooltipVisible(false);
    }, []);

    const onClose = useCallback(() => {
        setIsTooltipVisible(false);
    }, []);

    if (!shouldRenderTooltip) {
        return <span>{displayText}</span>;
    }

    return (
        <span className={styles['container']} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <span className={styles['label']}>{displayText}</span>
            <CRATagsTooltip
                tags={craTags}
                publishers={publishers}
                campaignId={campaignId}
                creativeId={creativeId}
                accountName={accountName}
                initialSelected={initialSelected}
                onClose={onClose}
                showing={isTooltipVisible}
            />
        </span>
    );
};

ReachCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    isStatusRejected: PropTypes.func,
    msgIdPrefix: PropTypes.string,
};

export default ReachCellRenderer;
